export default __webpack_public_path__ + "static/media/tier-2.52c3a77d.png";